module.exports = __webpack_public_path__ + "img/solution-v2x-system-pic.fb2ba0fd.png";